import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="product-variants"
export default class extends Controller {
  connect() {
    this.form = this.element.closest("form");
    this.update = this.update.bind(this);

    this.lotInputs.forEach((input) =>
      input.addEventListener("change", this.update),
    );
    this.element.addEventListener("cocoon:after-insert", this.update);
    this.element.addEventListener("cocoon:after-remove", this.update);

    this.update();
  }

  disconnect() {
    this.lotInputs.forEach((input) =>
      input.removeEventListener("change", this.update),
    );
  }

  get lotInputs() {
    return this.form?.querySelectorAll('input[name*="product_lot"]') ?? [];
  }

  get rows() {
    return Array.from(this.element.querySelectorAll(".nested-fields")).filter(
      (row) => row.style.display !== "none",
    );
  }

  get isLot() {
    return (
      this.form?.querySelector('input[name*="product_lot"]:checked')?.value ===
      "true"
    );
  }

  update() {
    const isLot = this.isLot;

    this.element
      .querySelector(".js-variant-add")
      ?.classList.toggle("d-none", !isLot);

    this.rows.forEach((row, index) => {
      const extra = !isLot && index > 0;

      row.classList.toggle("d-none", extra);
      row.querySelector(".js-variant-name")?.classList.toggle("d-none", !isLot);
      row
        .querySelector(".js-variant-remove")
        ?.classList.toggle("d-none", !isLot || index === 0);

      const destroy = row.querySelector('input[name*="_destroy"]');
      if (destroy) destroy.value = extra ? "1" : "";

      if (!isLot) {
        const name = row.querySelector('.js-variant-name input[type="text"]');
        if (name) name.value = "";
      }
    });
  }
}
